export const getVersionedLink = function(link) {
	if (typeof appContext === "undefined") {
		return link;
	}
	return link + "?ver=" + appContext.version;
};

export class ResourceLoader {
	constructor(versFunc){
		this.head = document.getElementsByTagName("head")[0] || document.documentElement;
		if(!versFunc){
			this.getVersionedLink = getVersionedLink;
		}
		else{
			this.getVersionedLink = versFunc;
		}
	}
	//функция загрузки css
	loadStyleSheet(src) {
		src = this.getVersionedLink(src);
		if (document.createStyleSheet) {
			document.createStyleSheet(src);
		} else {
			$(this.head).append($(`<link rel='stylesheet' href='${src}' type='text/css' media='screen' />`));
		}
	};
	
	//функция загрузки скрипта
	loadScript(src, onLoadHandler) {
		let executed = false;

		const loadHandler = (resolve, reject) => {
			const script = document.createElement("script");
			const scriptUrl = this.getVersionedLink(src);
			script.src = scriptUrl;
			script.async = false;
			
			const afterLoad = () => {
				if (onLoadHandler) { 
					onLoadHandler(src);
				}

				if (this.head && script.parentNode) {
					return this.head.removeChild(script);
				}
			};
					
			script.onload = () => {
				if (executed) {
					return;
				}
					
				executed = true;
				afterLoad();
				resolve();
			};
			
			script.onreadystatechange = () => {
				const self = this;
				
				if ((this.readyState === "complete") || (this.readyState === "loaded")) {
					return setTimeout(() => self.onload(), 0);
				}
			};

			script.onerror = () => {
				reject();
			};

			this.head.insertBefore(script, this.head.firstChild);
		};

		if(typeof(Promise) === "undefined"){
			//обратная совместимость с IE
			let def = $.Deferred();
			loadHandler(() => def.resolve(script));
			return def.promise();
		}

		return new Promise(loadHandler);
	};
}